import { SvgCurve, SvgTxt, MaterialRecord, MaterialSvg } from "../components/DrawMtrlCurve";

function TimberCurve(activeMtrl: MaterialRecord, svg: MaterialSvg): [SvgCurve[], SvgTxt[]] {
  const maxW = svg.max.x;
  const maxH = svg.max.y;

  // stress-strain curve --------------------------------

  let curve1: SvgCurve = {
    stroke: "green",
    width: "1",
    dash: "",
    data: "",
  };

  curve1.data = "M" + svg.origo.x.toString() + "," + svg.origo.y.toString() + " ";

  curve1.data += "l" + maxW.toString() + "," + (-maxH).toString();

  // 'fuk'-line  --------------------------------

  let curve2: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve2.data = "M" + (svg.origo.x - 5).toString() + "," + (svg.origo.y - maxH).toString() + " ";
  curve2.data += "l" + (maxW + 5).toString() + ",0";

  // 'eps_cu'-line  --------------------------------

  let curve3: SvgCurve = {
    stroke: "black",
    width: "1",
    dash: "5,5",
    data: "",
  };

  curve3.data = "M" + (svg.origo.x + maxW).toString() + "," + (svg.origo.y + 5).toString() + " ";
  curve3.data += "l" + "0," + (-(maxH + 5)).toString();

  //---- collect curves -----------------

  let curves = [curve1, curve2, curve3];

  //---- texts -----------------

  let txts: SvgTxt[] = [
    {
      x: (svg.origo.x + maxW).toString(),
      y: (svg.origo.y + 20).toString(),
      style: {
        fontSize: "30px",
        fontStyle: "italic",
      },
      text: "&epsilon;",
    },
    {
      x: (svg.origo.x + 9 + maxW).toString(),
      y: (svg.origo.y + 25).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "t,u",
    },
    {
      x: (svg.origo.x - 25).toString(),
      y: (svg.origo.y - maxH).toString(),
      style: {
        fontSize: "20px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "f",
    },
    {
      x: (svg.origo.x - 20).toString(),
      y: (svg.origo.y + 5 - maxH).toString(),
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        fontStyle: "italic",
      },
      text: "t",
    },
  ];

  return [curves, txts];
}

export default TimberCurve;
